import redact, { type RedactOptions } from 'fast-redact';

export const withRedactedPaths =
  (options?: Omit<RedactOptions, 'serialize'>) =>
  <T extends object>(record: T) =>
    redact({ ...options, serialize: false })({
      ...record,
    }) as T;
